import { Node } from 'tiptap'
import Vue from 'vue'
import EditorVideoVueComponent from '~/components/editor-Video'

export default class Video extends Node {
   get name() {
      return 'video'
   }

   get schema() {
      return {
         attrs: {
            src: {
               default: {
                  inputSrc: null,
                  embedUrl: null,
               },
            },
         },
         inline: false,
         group: 'block',
         isLeaf: true,
         selectable: false,
         draggable: true,
         // parseDOM: [
         //    {
         //       tag: 'iframe',
         //       getAttrs: dom => ({
         //          src: dom.getAttribute('src'),
         //       }),
         //    },
         // ],
         // toDOM: node => [
         //    'iframe',
         //    {
         //       src: `https://www.youtube.com/embed/${node.attrs.src}`,
         //       frameborder: 0,
         //       allowfullscreen: 'true',
         //       allow: 'accelerometer; encrypted-media; gyroscope; picture-in-picture',
         //       // You can set the width and height here also
         //    },
         // ],
         toDOM: node => {
            var ComponentClass = Vue.extend(EditorVideoVueComponent)
            var instance = new ComponentClass({
               propsData: { node, view: this.view },
            })
            // instance.$slots.default = ['Click me!']
            instance.$mount() // pass nothing
            return instance.$el
         },
      }
   }

   commands({ type }) {
      return attrs => (state, dispatch) => {
         const node = type.create(attrs)

         // This puts the new node on a new line
         // const { selection } = state
         // const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos
         // const transaction = state.tr.insert(position, node)

         // This puts the node on the current line
         const transaction = state.tr.replaceSelectionWith(node, false)

         dispatch(transaction)
      }
   }

   get view() {
      return EditorVideoVueComponent
   }
}
